import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Supabase Auth redirects here after OAuth (implicit flow).
 *
 *  The URL hash contains access_token + refresh_token. AuthContext's
 *  bootstrap() handles all token processing (detectSessionInUrl,
 *  captured hash tokens fallback, and PKCE code exchange).
 *
 *  We simply wait for the FULL AuthContext state to resolve (session
 *  found + team_roster lookup done) before navigating. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loading, session, member } = useAuth();

  // Wait for auth to fully resolve, then navigate
  useEffect(() => {
    if (loading) return; // Still resolving — wait

    if (session && member) {
      // Fully authenticated + team roster matched → go home
      navigate("/", { replace: true });
    } else if (session && !member) {
      // Authenticated but not in team_roster → unauthorized
      navigate("/unauthorized", { replace: true });
    } else {
      // No session after full resolution — shouldn't happen on a
      // legit callback, but handle gracefully. Give Supabase a moment
      // to process the hash before giving up.
      const timer = setTimeout(() => {
        navigate("/login", { replace: true });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [loading, session, member, navigate]);

  return (
    <div className="h-screen flex items-center justify-center text-slate-500">
      Signing you in…
    </div>
  );
}
